import React from 'react';
import { withPropsOnChange } from 'recompose';

import { TruckFilterContent } from 'components/search/TruckFilterContent';
import { SearchFilters } from 'components/organisms/SearchFilters';

export default withPropsOnChange(
	['isTruckSerp', 'isVehicleSerp', 'facetCounts'],
	({ isTruckSerp, isVehicleSerp, handleShowUnitGuide, facetCounts }) => {
		let filterComponent = (
			<SearchFilters
				isVehicle={false}
				facetCounts={facetCounts}
				onShowUnitGuide={handleShowUnitGuide}
			/>
		);

		if (isTruckSerp) {
			filterComponent = <TruckFilterContent />;
		} else if (isVehicleSerp) {
			filterComponent = (
				<SearchFilters
					isVehicle={true}
					facetCounts={facetCounts}
					onShowUnitGuide={handleShowUnitGuide}
				/>
			);
		}

		return {
			filterComponent,
			listType: isTruckSerp ? 'grid' : 'column',
		};
	},
);
